// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.Username_glass__8UdM0 {
  background: rgba(255, 255, 255, 0.55);
  border-radius: 16px;
  box-shadow: 0 4px 30px #4747470b;
  -webkit-backdrop-filter: blur(7.1px);
          backdrop-filter: blur(7.1px);
  border: 1px solid rgba(255, 255, 255, 0.3);
  @apply border-4 border-gray-50 shrink-0 h-3/4 w-[30%] rounded-3xl py-20 px-7 min-w-max;
}

.Username_profile_img__3ay6O {
  @apply border-4 border-gray-100 w-[135px] rounded-full shadow-lg cursor-pointer;
  @apply hover:border-gray-200;
}

.Username_textbox__ZqJBP {
  @apply border-0 px-5 py-4 rounded-xl w-3/4 shadow-sm text-lg;
  @apply focus:outline-none;
}

.Username_btn__j0KNh {
  @apply border bg-indigo-500 w-3/4 py-4 rounded-lg text-gray-50 text-xl shadow-sm text-center;
}

.Username_btn__j0KNh:hover {
  background-color: #ff6a6a;
}

input[type="file"] {
  display: none;
}
`, "",{"version":3,"sources":["webpack://./src/styles/Username.module.css"],"names":[],"mappings":"AAAA;EACE,qCAAqC;EACrC,mBAAmB;EACnB,gCAAgC;EAChC,oCAA4B;UAA5B,4BAA4B;EAC5B,0CAA0C;EAC1C,sFAAsF;AACxF;;AAEA;EACE,+EAA+E;EAC/E,4BAA4B;AAC9B;;AAEA;EACE,4DAA4D;EAC5D,yBAAyB;AAC3B;;AAEA;EACE,4FAA4F;AAC9F;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,aAAa;AACf","sourcesContent":[".glass {\n  background: rgba(255, 255, 255, 0.55);\n  border-radius: 16px;\n  box-shadow: 0 4px 30px #4747470b;\n  backdrop-filter: blur(7.1px);\n  border: 1px solid rgba(255, 255, 255, 0.3);\n  @apply border-4 border-gray-50 shrink-0 h-3/4 w-[30%] rounded-3xl py-20 px-7 min-w-max;\n}\n\n.profile_img {\n  @apply border-4 border-gray-100 w-[135px] rounded-full shadow-lg cursor-pointer;\n  @apply hover:border-gray-200;\n}\n\n.textbox {\n  @apply border-0 px-5 py-4 rounded-xl w-3/4 shadow-sm text-lg;\n  @apply focus:outline-none;\n}\n\n.btn {\n  @apply border bg-indigo-500 w-3/4 py-4 rounded-lg text-gray-50 text-xl shadow-sm text-center;\n}\n\n.btn:hover {\n  background-color: #ff6a6a;\n}\n\ninput[type=\"file\"] {\n  display: none;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"glass": `Username_glass__8UdM0`,
	"profile_img": `Username_profile_img__3ay6O`,
	"textbox": `Username_textbox__ZqJBP`,
	"btn": `Username_btn__j0KNh`
};
export default ___CSS_LOADER_EXPORT___;
